<template>
  <div class="main">
    <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form" @submit="handleSubmit">
      <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px" :message="errorMsg" />
      <a-form-item>
        <!-- { validator: handleUsernameOrEmail }, -->
        <a-input size="large" type="text" placeholder="请输入登录名" v-decorator="[
          'username',
          {
            rules: [{ required: true, message: '请输入登录名' }, { min: 2, max: 20, message: '用户名错误' },{pattern:/^[a-zA-Z0-9]+$/,message:'请输入正确用户名'}],
            validateTrigger: 'change',
          },
        ]">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input-password size="large" placeholder="请输入密码" v-decorator="[
          'password',
          {
            rules: [{ required: true, message: '请输入密码' }, { min: 6, max: 16, message: '密码错误' }],
            validateTrigger: 'blur',
          },
        ]">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-item>
      <a-form-item class="lastFormItem">
        <a-input size="large" style="width: 63%; margin-right: 5px" type="text" placeholder="验证码" v-decorator="[
          'code',
          {
            rules: [{ required: true, message: '请输入验证码' }],
          },
        ]" />
        <img style="width: 35%; height: 40px; margin-top: -6px; cursor: pointer" :src="imgsrc" @click="chang_code" />
      </a-form-item>
      <div >
        <a-checkbox class="forge-password" v-decorator="['rememberMe', { valuePropName: 'checked' }]">自动登录</a-checkbox>
        <router-link :to="{ name: 'register' }" class="forge-password" style="float: right; font-weight: 700;">忘记密码?
        </router-link>
      </div>
      <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="state.loginBtn" :style="{'background':colorThem}"
        :disabled="state.loginBtn" >确定</a-button>
    </a-form>

    <two-step-captcha v-if="requiredTwoStepCaptcha" :visible="stepCaptchaVisible" @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"></two-step-captcha>
    <Verify @success="capctchaCheckSucc" :mode="'pop'" :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>
  </div>
</template>

<script>
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import Verify from '@/components/verifition/Verify'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import md5 from 'md5'
// eslint-disable-next-line no-unused-vars
import { getSmsCaptcha, get2step, code } from '@/api/login'
import { axios } from '@/utils/request'
export default {
  components: {
    TwoStepCaptcha,
    Verify,
  },
  data() {
    return {
      capctchaCheck: false,
      verify: '',
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      isLoginError: false,
      errorMsg: '',
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false,
      },
      imgsrc: '',
      uuid: '',
      colorThem:''
    }
  },
  created() {
    
    this.get_code()

    // request({
    //   method: 'get',
    //   url: '/ping',
    // }).then((res) => console.log(res))
    // get2step({ })
    //   .then(res => {
    //     this.requiredTwoStepCaptcha = res.result.stepCode
    //   })
    //   .catch(() => {
    //     this.requiredTwoStepCaptcha = false
    //   })
    // this.requiredTwoStepCaptcha = true
  },
  mounted(){
    setTimeout(()=> {
      this.colorThem=localStorage.getItem('loginColor')? localStorage.getItem('loginColor'): '#1890ff'
    },1000)
    console.log(localStorage.getItem('loginColor'), 'localStorage.getItem=========================')
    
  },
  methods: {
    chang_code() {
      this.get_code()
    },
    get_code() {
      code().then((res) => {
        this.imgsrc = 'data:image/gif;base64,' + res.img
        this.uuid = res.uuid
      })
    },
    ...mapActions(['Login', 'Logout']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      // const { state } = this
      // const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      // if (regex.test(value)) {
      //   state.loginType = 0
      // } else {
      //   state.loginType = 1
      // }
      // callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    capctchaCheckSucc(data) {
      this.capctchaCheck = true
      this.verify = data.captchaVerification
      this.loginForm()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loginForm()
    },
    loginForm() {
      // routers

      this.$store.state.permission.addRouters = []
      this.$store.state.permission.routers = []
      // if (!this.capctchaCheck) {
      //   this.$refs.verify.show()
      //   return false
      // }
      setTimeout(() => {
        const {
          form: { validateFields },
          state,
          customActiveKey,
          Login,
        } = this
        state.loginBtn = true
        const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password', 'code'] : ['mobile', 'captcha']
        validateFields(
          validateFieldsKey,
          {
            force: true,
          },
          (err, values) => {
            if (!err) {
              values['uuid'] = this.uuid
              console.log('login form', process.env.VUE_APP_MODEL_BASE_URL)
              const loginParams = { ...values }
              delete loginParams.username
              // !state.loginType ? 'email' : 
              loginParams['username'] = values.username
              // loginParams.password = md5(values.password)
              const captchaVO = {
                captchaVerification: this.verify,
              }
              loginParams.captchaVO = captchaVO
              Login(loginParams)
                .then((res) => this.loginSuccess(res))
                .catch((err) => this.requestFailed(err))
                .finally(() => {
                  state.loginBtn = false
                  this.capctchaCheck = false
                })
            } else {
              setTimeout(() => {
                this.get_code()
                state.loginBtn = false
              }, 600)
            }
          }
        )
      }, 500)
    },
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
      } = this

      validateFields(
        ['mobile'],
        {
          force: true,
        },
        (err, values) => {
          if (!err) {
            state.smsSendBtn = true

            const interval = window.setInterval(() => {
              if (state.time-- <= 0) {
                state.time = 60
                state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)

            const hide = this.$message.loading('验证码发送中..', 0)
            getSmsCaptcha({
              mobile: values.mobile,
            })
              .then((res) => {
                setTimeout(hide, 2500)
                this.$notification['success']({
                  message: '提示',
                  description: '验证码获取成功，您的验证码为：' + res.result.captcha,
                  duration: 8,
                })
              })
              .catch((err) => {
                setTimeout(hide, 1)
                clearInterval(interval)
                state.time = 60
                state.smsSendBtn = false
                this.requestFailed(err)
              })
          }
        }
      )
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess(res) {
      if (res.code === 200) {
        this.$router.push(
          {
            name: 'dashboard',
          },
          () => {
            this.$notification.success({
              message: '欢迎',
              description: `${timeFix()}，欢迎回来`,
            })
          }
        )
        this.isLoginError = false
      } else {
        this.$refs.verify.refresh()
        this.requestFailed(res)
      }
    },
    requestFailed(err) {
      this.get_code()
      this.isLoginError = true
      this.errorMsg = ((err.response || {}).data || {}).msg || err.msg || '运行时异常:请联系管理员！'
      // this.$notification['error']({
      //   message: '错误',
      //   description: this.errorMsg,
      //   duration: 4,
      // })

    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 0 30px;
  box-sizing: border-box;
}

.ant-form-item {
  margin-bottom: 15px !important;
}
.lastFormItem {
  margin-bottom: 8px !important;
}

.user-layout-login {
  margin-top: 30px;

  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 16px;
    font-weight: 600;
  }

  button.login-button {
    padding: 0 15px;
    // background-image: linear-gradient(#F5515F, #9F041B);
    border: none;
    font-size: 16px;
    height: 40px;
    width: 100%;
    margin-top: 18px;
    background: #1890ff
    // -webkit-linear-gradient(left, #DD1414, #FC4343);
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
